import React from 'react'
import { shallowEqual, useSelector } from "react-redux";
import {Heading, SubHeading, NameOnly2} from "./BlockParts/index";

export default function NameOnlyBlock2({options,items,idx,settings}) {
  const FontSettings = useSelector((state) => {
    const fontStyle = state.project?.fontStyle || {};
    return {
      heading: fontStyle.heading,
      subHeading: fontStyle.subHeading,
      nameOnlyStyle: fontStyle.nameOnlyStyle,
    };
  }, shallowEqual);
  return (
    <div key={idx} id={"block_" + idx} className="text-[18px] w-full flex flex-col justify-center px-1">
      <Heading options={options} fontStyle={FontSettings?.heading} idx={idx} />
      <SubHeading options={options} fontStyle={FontSettings?.subHeading} idx={idx} />
      <NameOnly2 options={options} fontStyle={FontSettings} items={items} idx={idx} settings={settings} />
    </div>
  )
}
